// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"cff228a6","50":"5c16abe6","929":"8f0569df"}[chunkId] + ".chunk.css";
};